export const GET_FILTER_NEW_OPTIONS = 'app/Filter/GET_FILTER_NEW_OPTIONS'
export const GET_FILTER_NEW_OPTIONS_DONE =
  'app/Filter/GET_FILTER_NEW_OPTIONS_DONE'
export const GET_FILTER_NEW_OPTIONS_ERROR =
  'app/Filter/GET_FILTER_NEW_OPTIONS_ERROR'

export const CREATE_FILTER_NEW = 'app/Filter/CREATE_FILTER_NEW'
export const CREATE_FILTER_NEW_DONE = 'app/Filter/CREATE_FILTER_NEW_DONE'
export const CREATE_FILTER_NEW_ERROR = 'app/Filter/CREATE_FILTER_NEW_ERROR'

export const RESET_FILTER_NEW = 'app/Filter/RESET_FILTER_NEW'

export const SAVE_IN_DEEP_ASYNC_DICTIONARY =
  'app/Filter/SAVE_IN_DEEP_ASYNC_DICTIONARY'

export const GET_USERS = 'app/Filter/GET_USERS'
export const GET_USERS_DONE = 'app/Filter/GET_USERS_DONE'
export const GET_USERS_ERROR = 'app/Filter/GET_USERS_ERROR'

export const GET_DATASETS = 'app/Filter/GET_DATASETS'
export const GET_DATASETS_DONE = 'app/Filter/GET_DATASETS_DONE'
export const GET_DATASETS_ERROR = 'app/Filter/GET_DATASETS_ERROR'

export const GET_DATASET_RECORDS = 'app/Filter/GET_DATASET_RECORDS'
export const GET_DATASET_RECORDS_DONE = 'app/Filter/GET_DATASET_RECORDS_DONE'
export const GET_DATASET_RECORDS_ERROR = 'app/Filter/GET_DATASET_RECORDS_ERROR'

export const GET_GROUPS = 'app/Filter/GET_GROUPS'
export const GET_GROUPS_DONE = 'app/Filter/GET_GROUPS_DONE'
export const GET_GROUPS_ERROR = 'app/Filter/GET_GROUPS_ERROR'

export const GET_RECORD = 'app/Filter/GET_RECORD'
export const GET_RECORD_DONE = 'app/Filter/GET_RECORD_DONE'
export const GET_RECORD_ERROR = 'app/Filter/GET_RECORD_ERROR'

export const ENTITIES = {
  pins: 'Pins',
  media: 'Media',
  tasks: 'Tasks'
}

export const mediaTypes = ['Image', 'Video', 'Audio', 'Text', 'PDF', 'Unknown']

export const FilterForNotDisableOptions = {
  DATASET: 'DataSet',
  DATA_SET_RECORD: 'DataSetRecord',
  PIN_FIELD: 'PinField'
}
